import angular from 'angular';

export const withCustomStyledBody = $document => ({
    restrict: 'A',
    link(scope, element, attrs) {
        const body = angular.element($document).find('body');
        body.addClass('custom-styled-body');
        body.css({
            background: '#f6f6f6',
        });
    },
});

angular
    .module('TALENYA-FE')
    .directive('withCustomStyledBody', withCustomStyledBody);
